import { __decorate } from "tslib";
import { NgModule } from 'angular-ts-decorators';
import { LanguageSelectComponent } from './language-select/language-select.component';
import { SupportSectionV2Component } from './support-section-v2/support-section-v2.component';
import { ScrollToOnClickDirective, ScrollToOnLoadDirective } from './directives';
import { EventHelperService, FaqContextService, HashSeekerService, ItemScrollerService, ProductContextService, SectionHelperService, SectionTogglerService, VideoContextService, } from './services';
var moduleId = 'gn.audio.support.design';
var SupportDesignModule = (function () {
    function SupportDesignModule() {
    }
    SupportDesignModule = __decorate([
        NgModule({
            declarations: [
                LanguageSelectComponent,
                SupportSectionV2Component,
                ScrollToOnClickDirective,
                ScrollToOnLoadDirective,
            ],
            id: moduleId,
            imports: [],
            providers: [
                EventHelperService,
                FaqContextService,
                HashSeekerService,
                ItemScrollerService,
                ProductContextService,
                SectionHelperService,
                SectionTogglerService,
                VideoContextService,
            ],
        })
    ], SupportDesignModule);
    return SupportDesignModule;
}());
export { SupportDesignModule };
